(function ($, Drupal) {
  "use strict";

  Drupal.behaviors.paragraph_testimonial = {
    attach: function (context, settings) {
      $(once("slick", ".paragraph--view-mode--default .field--name-field-testimonials")).each(function (_, $el) {
        $($el)
          .find(".testimonial-arrow.previous")
          .click(function () {
            $($el).slick("slickPrev");
          });

        $($el)
          .find(".testimonial-arrow.next")
          .click(function () {
            $($el).slick("slickNext");
          });

        if ($($el).find(".node--testimonial").length < 2) {
          $($el).addClass("no-slider");
          $($el).find(".testimonial-arrow.previous").remove();
          $($el).find(".testimonial-arrow.next").remove();
        }

        $($el).slick({
          fade: true,
          swipe: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          lazyLoad: "progressive",
          arrows: false,
          useTransform: false,
        });
      });

      $(once("slick", ".paragraph--view-mode--no_media .field--name-field-testimonials")).slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"></div>',
        nextArrow: '<div class="slick-next"></div>',
        arrows: true,
        fade: true,
        lazyLoad: "progressive",
      });
    },
  };
})(jQuery, Drupal);
